import dayjs from 'dayjs'

export const isSameDay = (dateLeft, dateRight) => {
  if (!dateLeft || !dateRight) return false
  return dayjs(dateLeft).isSame(dateRight, 'day')
}

export const isSameMonth = (dateLeft, dateRight) => {
  if (!dateLeft || !dateRight) return false
  return dayjs(dateLeft).isSame(dateRight, 'month')
}

export const isToday = (date) => isSameDay(date, new Date())
export const isYesterday = (date) => isSameDay(date, dayjs().subtract(1, 'day'))
export const isTomorrow = (date) => isSameDay(date, dayjs().add(1, 'day'))
export const isThisYear = (date) => dayjs(date).year() === dayjs().year()

export const eachDayOfInterval = ({ start, end }) => {
  const arr = []
  const startDate = dayjs(start).toDate()
  const endDate = dayjs(end).toDate()
  let i = startDate
  while (i <= endDate) {
    arr.push(i)
    i = dayjs(i).add(1, 'day').toDate()
  }
  return arr
}

export const parseHumanTime = (date, defaultPattern = '') => {
  if (isToday(date)) return 'Today'
  else if (isYesterday(date)) return 'Yesterday'
  else if (isTomorrow(date)) return 'Tomorrow'
  if (defaultPattern) return dayjs(date).format(defaultPattern)
  else if (!isThisYear(date)) return dayjs(date).format('DD MMM YYYY')
  else return dayjs(date).format('DD MMM')
}

// 求两个时间的时间差, 格式化显示文案
export const diffHumanTime = (time1, time2) => {
  const days = dayjs(time1).diff(time2, 'day')
  if (days > 0) return `${days} ${days === 1 ? 'day' : 'days'} ago`

  const hours = dayjs(time1).diff(time2, 'hour')
  if (hours > 0) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`

  const minutes = dayjs(time1).diff(time2, 'minute')
  return minutes > 1 ? `${minutes} minutes ago` : 'Just Now'
}


/**
 * Formats a given timestamp into a human-readable string based on specific conditions.
 *
 * - If the timestamp is within the current year:
 *   - Returns a formatted string in the format `D-MMM` (e.g., `5-JAN`).
 *   - If the parsed human-readable time starts with a digit, it returns the parsed time in uppercase.
 *   - Otherwise, it appends the parsed human-readable time to the formatted string.
 * - If the timestamp is not within the current year:
 *   - Returns a formatted string in the format `D-MMM YYYY` (e.g., `5-JAN 2022`).
 *
 * @param {number|string} time - The timestamp to format, either as a number or a string.
 * @returns {string} The formatted time string in uppercase.
 */
export const getMyMatchesTimeStr = (time) => {
  time = parseInt(time)
  let timeStr = ''
  if (new Date(time).getFullYear() === new Date().getFullYear()) {
    const hunmanTime = parseHumanTime(time, 'D-MMM')
    timeStr = dayjs(time).format('D-MMM').toUpperCase()
    if (/^\d/.test(hunmanTime)) {
      return hunmanTime.toUpperCase()
    } else {
      return timeStr + ' ' + hunmanTime
    }
  } else {
    return dayjs(time).format('D-MMM YYYY').toUpperCase()
  }
}
